import styled, { css } from 'styled-components';
import getStylesByNodeType from '../../../../../helpers/getStylesByNodeType';
import { NodeType } from '../../../../../types/Contentful.types';
import { ContentButtonRank } from '../types/SectionHero.types';
import { respondTo } from '@legacy-vfuk/core-mixins';

const themeBreakpointsSm = '500px'; // current value of theme.breakpoints.sm is zero

type FiftyFiftyBannerWrapperProps = {
  bodyPosition?: 'left' | 'right';
  textColor?: string;
  textAlign: string;
  textNodeType?: NodeType;
  headingNodeType?: NodeType;
  buttonRank?: ContentButtonRank;
};

type HeroBannerWrapperProps = {
  textPosition: 'left' | 'center' | 'right';
  textColor?: string;
  textAlign: string;
  textNodeType?: NodeType;
  headingNodeType?: NodeType;
  buttonRowAlignment: 'left' | 'centre' | 'right';
  buttonRank?: ContentButtonRank;
};

export const FiftyFiftyBannerWrapper = styled.div<FiftyFiftyBannerWrapperProps>`
  h1,
  h2,
  h3,
  h4,
  h5,
  p {
    color: ${({ textColor }) => (textColor ? textColor : '#000')};
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    font-weight: 200;
  }
  p {
    font-weight: 400;
  }

  @media only screen and (min-width: ${({ theme }) => theme.breakpoints.lg}px) {
    height: 25rem;
  }

  [class*='FiftyFiftyBannerstyle__FiftyFiftyBanner-sc'] {
    overflow: hidden;
    min-height: 25rem;

    @media only screen and (max-width: ${themeBreakpointsSm}) {
      min-height: 19.6875rem;
    }

    > [class*='FiftyFiftyBannerstyle__BannerContent-sc'] {
      justify-content: center;
      background-color: white;
      max-height: 25rem;

      @media only screen and (min-width: ${({ theme }) =>
          theme.breakpoints.lg}px) {
        transform: ${({ bodyPosition }) =>
          bodyPosition === 'right' ? 'skewX(-22.7deg)' : 'skewX(22.7deg)'};
        margin-right: ${({ bodyPosition }) =>
          bodyPosition === 'right' ? '0' : '-6rem'};
        margin-left: ${({ bodyPosition }) =>
          bodyPosition === 'right' ? '-6rem' : '0'};
        z-index: 1;
      }

      > [class*='FiftyFiftyBannerstyle__ContentWrapper-sc'] {
        @media only screen and (min-width: ${({ theme }) =>
            theme.breakpoints.lg}px) {
          transform: ${({ bodyPosition }) =>
            bodyPosition === 'right' ? 'skewX(22.7deg)' : 'skewX(-22.7deg)'};
          padding-left: ${({ bodyPosition }) =>
            bodyPosition === 'right' ? '0' : 'calc(50% - 300px)'};
        }

        > [class*='BannerBodystyle__BannerBody-sc'] {
          @media only screen and (min-width: ${({ theme }) =>
              theme.breakpoints.lg}px) {
            width: 21rem;
          }

          > [class*='BannerBodystyle__BannerContent-sc'],
          [class*='BannerButtons-sc'] {
            text-align: ${({ textAlign }) =>
              textAlign === 'right'
                ? 'right'
                : textAlign === 'left'
                ? 'left'
                : textAlign === 'center'
                ? 'center'
                : undefined};

            > [class*='Headingstyle__Heading-sc'] {
              ${({ headingNodeType, theme }) =>
                getStylesByNodeType(theme, headingNodeType)}
            }
            > [class*='Paragraphstyle__Paragraph-sc'] {
              ${({ textNodeType, theme }) =>
                getStylesByNodeType(theme, textNodeType)}
            }
          }

          > [class*='BannerBodystyle__BannerButtons-sc'] {
            a {
              background-color: ${({ buttonRank }) =>
                buttonRank === 'primary'
                  ? '#e60000'
                  : buttonRank === 'secondary'
                  ? '#666'
                  : undefined};
              @media only screen and (max-width: ${({ theme }) =>
                  theme.breakpoints.md}px) {
                width: unset;
              }
            }
            a:hover {
              background-color: ${({ buttonRank }) =>
                buttonRank === 'primary'
                  ? '#900'
                  : buttonRank === 'secondary'
                  ? '#333'
                  : undefined};
            }
          }
        }
      }
    }

    > [class*='FiftyFiftyBannerstyle__BannerImage-sc'] {
      flex-grow: 1;
      min-height: 25rem;

      @media only screen and (max-width: ${themeBreakpointsSm}) {
        min-height: 19.6875rem;
      }
    }
  }
`;

export const HeroBannerWrapper = styled.div<HeroBannerWrapperProps>`
  [class*='HeroBannerstyle__HeroBanner-sc'] {
    [class*='HeroBannerstyle__BannerContainer-sc'] {
      min-height: 25rem;
      max-width: 1200px;
      flex-direction: row;
      justify-content: ${({ textPosition }) =>
        textPosition === 'right'
          ? 'flex-end'
          : textPosition === 'left'
          ? 'flex-start'
          : undefined};

      @media only screen and (max-width: ${themeBreakpointsSm}) {
        min-height: 19.6875rem;
      }

      [class*='HeroBannerstyle__BannerContent-sc'] {
        padding: 0 0.75rem;
        margin-top: -2rem;
        width: unset;
        max-width: 45%;
        min-width: 300px;

        @media only screen and (max-width: ${({ theme }) =>
            theme.breakpoints.lg}px) {
          max-width: 60%;
          min-width: unset;
        }

        @media only screen and (max-width: ${themeBreakpointsSm}) {
          width: ${({ textPosition }) =>
            textPosition === 'right' ? '100%' : undefined};
          max-width: unset;
          min-width: unset;
        }

        [class*='HeroBannerstyle__ContentWrapper-sc'] {
          max-width: unset;
          [class*='BannerBodystyle__BannerBody-sc'] {
            display: flex;
            flex-direction: column;
            align-items: ${({ textAlign }) =>
              textAlign === 'right'
                ? 'right'
                : textAlign === 'left'
                ? 'left'
                : 'center'};

            h1,
            h2,
            h3,
            h4,
            h5,
            p {
              color: ${({ textColor }) => (textColor ? textColor : '#fff')};
              font-weight: 200;
              text-align: ${({ textAlign }) =>
                textAlign === 'right'
                  ? 'right'
                  : textAlign === 'left'
                  ? 'left'
                  : undefined};
            }

            [class*='Headingstyle__Heading-sc'] {
              ${({ headingNodeType, theme }) =>
                getStylesByNodeType(theme, headingNodeType)}
            }
            [class*='Paragraphstyle__Paragraph-sc'] {
              ${({ textNodeType, theme }) =>
                getStylesByNodeType(theme, textNodeType)}
            }
            [class*='BannerBodystyle__BannerButtons-sc'] {
              text-align: ${({ buttonRowAlignment }) =>
                buttonRowAlignment === 'centre' ? 'center' : undefined};
            }

            a {
              background-color: ${({ buttonRank }) =>
                buttonRank === 'primary'
                  ? '#e60000'
                  : buttonRank === 'secondary'
                  ? '#666'
                  : undefined};
              color: var(--white);
              width: unset;
            }
            a:hover {
              background-color: ${({ buttonRank }) =>
                buttonRank === 'primary'
                  ? '#900'
                  : buttonRank === 'secondary'
                  ? '#333'
                  : undefined};
            }
          }
        }
      }
      [class*='HeroBannerstyle__BannerImage-sc'] {
        display: none;
      }
    }
  }
`;

export const MouseIconWrapper = styled.div`
  @media (max-width: 1269px) {
    display: none;
  }

  position: absolute;
  bottom: 0;
  height: 40px;
  left: calc(50% - 12px);
  line-height: 100%;
  cursor: pointer;

  &:hover svg {
    margin-top: 10px;

    animation: MoveUpDown 0.8s linear infinite;
    @keyframes MoveUpDown {
      0%,
      100% {
        margin-top: 0;
      }
      50% {
        margin-top: 10px;
      }
    }
  }
`;

export const simpleGridColumnOverride = css`
  [data-component-name='SimpleGrid'] {
    margin: -12px;

    @media (min-width: 639px) {
      flex-wrap: nowrap;
    }
  }

  [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
    width: 100% !important;
    margin: 8px 12px;
  }

  @media (min-width: 639px) {
    [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
      width: unset !important;

      button {
        white-space: nowrap;
      }
    }
  }
`;

export const baseOuter = css`
  max-width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-position: 50%;
  background-size: cover;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  position: relative;

  @media (max-width: 1024px) {
  }

  @media (max-width: 639px) {
    background-position: center;
  }

  @media (max-width: 500px) {
    min-height: 203px;
  }
`;

export const textOverridesForBanners = css`
  [class^='RichTextstyles'] {
    h1 {
      margin: 0 0 12px 0;
    }
    h2,
    h3 {
      margin: 12px 0;
    }
    h4 {
      margin: 8px 0;
    }
    h5,
    h6,
    p {
      margin: 8px 0;
    }

    @media (min-width: 1025px) {
      h1 {
        font-weight: 600 !important;
        margin-bottom: 24px;
      }
      h5 {
        font-size: 28px;
        line-height: 32px;
        font-weight: lighter !important;
      }
    }

    @media (max-width: 639px) {
      h1 {
        margin: 0 0 8px 0;
      }
      h2,
      h3 {
        margin: 8px 0;
      }
      h4,
      h5,
      h6,
      p {
        margin: 6px 0;
      }
    }
  }
`;

export const ieLetsTalkBaseOuter = css`
  min-height: 339px;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2em;

  background-position: 50%;
  background-size: cover;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;

  @media (min-width: 1920px) {
    min-height: 400px;
  }

  @media (max-width: 870px) {
    min-height: 300px;
  }

  @media (max-width: 750px) {
    height: 450px;
    left: 0;
    flex-direction: column;
    justify-content: flex-end;
    margin-top: 0;
  }

  @media (max-width: 450px) {
    height: 375px;
  }
`;

export const outerLeft = css`
  justify-content: flex-start;
`;

export const outerRight = css`
  justify-content: flex-end;
`;

export const outerCenter = css`
  justify-content: center;
`;

export const middle = css`
  justify-content: center;
`;

export const outerCSS = {
  left: [baseOuter, outerLeft],
  right: [baseOuter, outerRight],
  center: [baseOuter, outerCenter],
  ieLetsTalk: [ieLetsTalkBaseOuter, middle],
};

export const baseWrapper = css`
  margin: 0 auto;
  max-width: 1200px;
  width: 100%;
`;

export const wrapperCSS = {
  left: [baseWrapper, outerLeft],
  right: [baseWrapper, outerRight],
  center: [baseWrapper, outerCenter],
  ieLetsTalk: [ieLetsTalkBaseOuter, middle],
};

export const hideOnMobile = css`
  display: none;
  @media (min-width: 639px) {
    display: block;
  }
`;

export const theMobileContentCSS = css`
  padding: 40px 20px 20px 20px;
  background-color: #ffffff;

  @media (min-width: 639px) {
    display: none;
  }

  .richText {
    * {
      color: #000000 !important;
    }

    h1 {
      line-height: 36px;
      font-size: 28px;
      font-weight: 700 !important;
      margin-bottom: 14px;

      @media (max-width: 320px) {
        line-height: 1 !important;
      }
    }

    img {
      filter: brightness(0%) contrast(100%);
    }
  }

  .button {
    width: 100% !important;
  }

  .button--tertiary-wrapper {
    button {
      background-color: #333;
      color: #ffffff;
      &:hover {
        background-color: #000;
        color: #ffffff;
        border-color: #000;
      }
    }
  }
`;

export const innerCommon = css`
  min-width: 300px;
  padding-inline-start: 10px;
  color: #ffffff;
`;

export const innerLeft = css`
  ${innerCommon}
  max-width: 50%;
  text-align: start;
  @media (max-width: 1024px) {
    max-width: 60%;
    min-width: unset;
    padding-left: 20px; // to line up with VF icon in top menu for tablet w2s.
  }
  @media (max-width: 639px) {
    max-width: 75%;
    min-width: unset;
    padding-left: 10px; // to line up with VF icon in top menu for mobile ws2.
  }
`;

export const innerRight = css`
  ${innerCommon}
  max-width: 45%;
  text-align: start;
  @media (min-width: 1930px) {
    margin-right: 10%;
  }
  @media (max-width: 1024px) {
    max-width: 60%;
    min-width: unset;
    padding: 0 70px; // tablet left-right margins for ws2.
    margin-top: 120px;
  }
  @media (max-width: 639px) {
    width: 100%;
    max-width: unset;
    min-width: unset;
    padding: 0 10px; // mobile left-right margins for ws2
    margin-top: 120px;
  }
`;

export const innerCenter = css`
  ${innerCommon}
  max-width: 60%;
  text-align: center;
  @media (max-width: 1024px) {
    max-width: unset;
    min-width: unset;
    padding: 0 20px; // tablet left-right margins for ws2.
  }
  @media (max-width: 639px) {
    padding: 0 10px; // mobile left-right margins for ws2
  }
`;

export const ieLetsTalk = css`
  height: 190px;
  position: relative;
  left: 15rem;
  color: #ffffff;

  div {
    text-align: left;
  }

  .heading {
    margin: 0;
    @media (max-width: 820px) {
      font-size: 28px;
    }

    @media (max-width: 720px) {
      font-size: 24px;
    }

    @media (max-width: 345px) {
      font-size: 22px;
    }
  }

  .ctaButton {
    &:hover {
      border: 1px solid var(--white);
    }
  }

  .richText {
    margin-bottom: 34px;

    @media (max-width: 750px) {
      text-align: center;
      margin-bottom: 16px;
    }

    @media (max-width: 375px) {
      text-align: center;
      margin-bottom: 16px;
    }
  }

  .ctaButonRow {
    justify-content: flex-start;
    padding: 0;

    @media (max-width: 750px) {
      justify-content: center;
    }

    @media (max-width: 375px) {
      align-items: center;
    }
  }

  @media (max-width: 1024px) {
    height: 168px;
    left: 12.5rem;
  }

  @media (max-width: 820px) {
    left: 11rem;
  }

  @media (max-width: 750px) {
    top: 16px;
    left: 0;
    text-align: center;
  }

  @media (max-width: 390px) {
    left: 0;
    margin-right: 0;
    margin-top: 188px;
    text-align: center;
  }

  @media (max-width: 375px) {
    margin-top: 0;
    top: 30px;
    text-align: center;
  }
`;

export const innerCSS = {
  left: innerLeft,
  right: innerRight,
  center: innerCenter,
  ieLetsTalk,
};

// CSS for slanted split banners.
export const SplitContainer = styled.div<{ direction: 'rtl' | 'ltr' }>`
  position: relative;
  display: flex;
  flex-direction: column;

  @media (min-width: 1025px) {
    display: grid;
    grid-template-columns: repeat(20, 1fr);
  }

  direction: ltr;
  * {
    direction: ${props => props.direction};
  }

  [class*='CtaButtonRowstyles__SimpleGridWrapper'] {
    [class*='SimpleGridstyle__SimpleGrid-sc'] {
      gap: 24px;
    }
    [spacing='12'] {
      margin: 0;

      width: 100%;
      @media (min-width: 640px) {
        width: unset;
      }

      .button {
        margin: 0 auto;
        width: 100%;
      }
    }
  }
`;

export const splitFirstImageCSS = css`
  order: 1;
  grid-column: 8 / 21;
  grid-row: 1;
  position: relative;
  background-position: 40% 30%;

  @media (max-width: 900px) {
    background-position: 45% 50%;
  }

  @media (max-width: 1024px) {
    max-width: initial;
    margin-left: initial;
    background-position: 50% 50%;
  }
`;

export const splitSecondImage = css`
  order: 2;
  grid-column: 1 / 12;
  grid-row: 1;
  z-index: 1;
  justify-content: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-position: 100% bottom;
  color: #000000;
  text-align: left;
  height: 100%;
  padding-right: 160px;

  @media (max-width: 900px) {
    max-width: 60%;
  }

  @media (max-width: 1024px) {
    justify-content: center;
    overflow: visible;
    position: initial;
    max-width: initial;
    background-position: 0% center;
    padding-right: 0;
  }
`;

export const splitSecondImageTextCSS = css`
  max-width: 445px;
  margin: 0 10px;

  @media (max-width: 1024px) {
    margin: 0 20px;
  }

  @media (max-width: 1024px) {
    max-width: initial;
  }

  @media (max-width: 639px) {
    margin: 0 10px;
  }
`;

export const WrapperSectionHero = styled.div<{ size: string }>`
  #section-hero-container {
    min-height: ${props => (props.size === 'small' ? '400px' : '692px')};

    @media (max-width: 1024px) {
      min-height: ${props => (props.size === 'small' ? '300px' : '500px')};
    }

    @media (max-width: 500px) {
      min-height: 203px;
    }
  }

  [class*='Heading'] {
    margin-top: 15px;
  }
  
  [class*='RichTextstyles'] > p:empty {
    display: none;
  }

  #section-hero-content {
    position: ${props => (props.size === 'small' ? 'unset' : 'absolute')};
    top: ${props => (props.size === 'small' ? 'unset' : '24%')};
  }

  [class^='RichTextstyles'] {
    @media (min-width: 1025px) {
      h5 {
        margin-bottom: ${props =>
          props.size === 'small' ? '20px !important' : '50px !important'};
      }
    }
  }
`;

export const AnimatedWrapper = styled.div`
  [data-component-name='SimpleGrid'] {
    flex-direction: column;

    @media (max-width: 794px) {
      [class^='SimpleGridstyle__SimpleGridColumn-sc'] {
        margin: 1.1em;
      }
      [class^='SimpleGridstyle__SimpleGrid-sc']:last-child {
        margin-top: 1.3em;
      }
      [class^='SimpleGridstyle__SimpleGridColumn-sc']:last-child {
        margin-top: 1.4em;
      }
    }

    ${respondTo.md(
      css`
        flex-direction: row;
      `
    )}
  }
  padding: 40px 20px;

  [class^='Headingstyle__Heading-sc'] {
    font-size: 100px;
    line-height: 105px;

    @media (max-width: 794px) {
      font-size: 32px;
      line-height: 40px;
    }
  }

  ${respondTo.md(
    css`
      padding: 150px 20px;
    `
  )}
`;

export const AnimationControlButtonContainer = styled.div`
  width: fit-content;

  margin-left: auto;
  margin-right: auto;

  margin-top: 15px;

  @media (max-width: 794px) {
    margin-top: 1.5em;
  }

  ${respondTo.lg(
    css`
      margin-top: 20px;
    `
  )}
`;
